import React, { forwardRef } from 'react';
import SwiperCore, { Autoplay, Pagination } from 'swiper';
import 'swiper/modules/pagination/pagination.scss';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import 'swiper/swiper.scss';
import TestimonialData from './TestimonialData';
import TestimonialDataFR from './TestimonialDataFr';
import Testimonial from './TestimonialItem';
import './Testimonials.css';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  testimonial: {
    paddingTop: '32px',
    paddingBottom: '32px',
    ['@media(max-width:768px)']: {
      paddingTop: '48px',
      paddingBottom: '48px',
    },
  },
});

SwiperCore.use([Autoplay, Pagination]);
const Testimonials = forwardRef((props, ref) => {
  const classes = useStyles();
  const { t } = useTranslation();
  let data;
  if (props.selectedLang === 'fr') {
    data = TestimonialDataFR;
  } else {
    data = TestimonialData;
  }
  return (
    <div className="demo" id="demo">
      <section
        id="testimonials"
        className={`testimonials ${classes.testimonial}`}
        testimonials
        ref={ref}
      >
        <div className="testimonial_container" style={{ maxWidth: '1300px' }}>
          <div
            className="section-title-blog section-title"
            style={{ marginBottom: '16px' }}
          >
            <h2 className="heading_tesimonial">
              {t('Sections-Testimonial-Testimonial-Head')}
            </h2>
            <p className="testimonial_subheading">
              {' '}
              {t('Sections-Testimonial-Testimonial-para')}
            </p>
          </div>
          <Swiper
            pagination={{ clickable: true }}
            autoHeight
            breakpoints={{
              380: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              500: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              992: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 2,
                spaceBetween: 60,
              },
              1300: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
            }}
            direction="horizontal"
          >
            {data.map((testimonial, i) => {
              return (
                <SwiperSlide key={i}>
                  <Testimonial testimonial={testimonial} />;
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </section>
    </div>
  );
});

export default Testimonials;
